import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { AbsoluteRoute } from "../absoluteRoutes";

export const useApiManagementRoutes = (): { goToApisList: () => void } => {
    const navigate = useNavigate();
    const goToApisList = useCallback(() => {
        navigate(AbsoluteRoute.APIS);
    }, [navigate]);

    return {
        goToApisList,
    };
};
